export default {"src":"/_next/static/media/zoom-out-white-32x32.5cb012a3.svg","height":32,"width":32};